/**
 * In-app address for a private storage file, e.g.
 * /view/attachments/6300…ec6d.pdf?name=EV.PDF
 * The page requires a Nomi login, so the link can be shared with the team
 * without making the file public.
 */
export const FILE_VIEWER_ROUTE = "/view/:bucket/*";

export const buildFileViewerPath = ({
  bucket,
  path,
  filename,
}: {
  bucket: string;
  path: string;
  filename?: string;
}) => {
  const encodedPath = path.split("/").map(encodeURIComponent).join("/");
  const query = filename ? `?name=${encodeURIComponent(filename)}` : "";
  return `/view/${encodeURIComponent(bucket)}/${encodedPath}${query}`;
};
